module.exports = __webpack_public_path__ + "img/people-and-laptop.111a2e04.svg";